import logo from './img/logo.png';
import "flag-icons/css/flag-icons.min.css";
import "./Teams.css";
let countries = require('./countries.json');

countries.sort((a, b) => {
    if (b.guest && !a.guest) return -1;
    if (a.guest && !b.guest) return 1;
    return (a.name > b.name ? 1 : -1);
})

function Team({ countryName, flagCode, participants, isGuest }) {
    return (
        <div class="team">
            <div class="title">
                <span class={`fi fi-${flagCode} fis`}></span>
                <h2> {isGuest ? <span><span>{countryName}</span> <i class='guest'>Guest</i></span> : (countryName)}</h2>
            </div>
            <div class="people">
                {participants.map(participant => (
                    <div class="person">
                        <img src={participant.photo} />
                        <span class="person-name"><b>{participant.first_name}</b></span>
                        <span class="person-name"><b>{participant.last_name}</b></span>
                        <span class="person-role">{participant.role}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

function Teams() {
    return (
        <div>
            <h1>Participants</h1>
            {countries.map(country => (
                <Team countryName={country.name} isGuest={country.guest} flagCode={country.flagCode} participants={country.participants} />
            ))}
        </div>
    );
}

export default Teams;
